

<template>
    <v-card>
        <v-toolbar dark flat :color="colorpick">
            <v-toolbar-title>
                <v-tooltip top eager close-delay=500 >
                    <template  v-slot:activator="{ on }">
                        <body slot="activator" v-on="on" @click="showTheBox=!showTheBox" :style="$store.state.textFormatting.headers"> {{top10Message}} </body>
                    </template>
                    <span :style="$store.state.textFormatting.main">
                        Will load the alerts that have happened to the user's selected ASNs <br /> 
                        The most recent day's events will always appear first <br /> 
                        Then the following most recent alerted day, then the rest of the days <br />
                        <b>Capped at 2000 alerts </b>
                    </span>
                </v-tooltip>
            </v-toolbar-title>
            <v-toolbar-title>
                <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                        <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see details) (times shown in {{ tz }})</small>         
                    </template>
                    <span :style="$store.state.textFormatting.main">(select row to see details)</span>
                </v-tooltip>
            </v-toolbar-title>

            <v-progress-circular v-if="loading" indeterminate color="white" > </v-progress-circular>

            <v-spacer></v-spacer>

            <v-tooltip top color="secondary" id="top10back10" v-if="!showUserTen">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="top10alerts('refresh')" fab small v-if="!loading"  icon><v-icon :style="$store.state.textFormatting.main"> refresh </v-icon></v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Refresh</span>
            </v-tooltip>

            <v-tooltip top color="secondary" id="top10back10" v-if="showUserTen">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="top10alertsUser('refresh')" fab small v-if="!loading"  icon><v-icon :style="$store.state.textFormatting.main"> refresh </v-icon></v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Refresh User</span>
            </v-tooltip>

            <v-flex shrink class="px-1">
                <v-tooltip top eager close-delay=500 >
                    <template v-slot:activator="{ on }">
                        <v-toolbar-title v-on="on">
                            <small>
                                <small :style="$store.state.textFormatting.main">
                                    {{ updatedStr }} 
                                </small>
                            </small>
                        </v-toolbar-title>
                    </template>
                    <span :style="$store.state.textFormatting.main"> {{ updatedStr }} </span>
                </v-tooltip>
            </v-flex>
            
            <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon depressed> <v-switch v-model="showUserTen"></v-switch> </v-btn>
                </template>
                <span :style="$store.state.textFormatting.main">Switch between global and user view</span>
            </v-tooltip>
            
            <info>
                <template slot>
                    <h3> View recent episodes </h3>
                </template>
                <template slot="body">
                    <p> Toggle (next to info) between <b> organisation </b> alerts (from organisation defined <b> ASNs </b> and <b> restricted prefixes</b>),
                        or a list of global episodes (i.e. irrespective of organisation defined ASNs/ prefixes). These, by default, are ordered by hijack score.
                    </p>
                    <br>
                    <p> Click the column headers to order the results. </p>
                      <br>
                    <p> Select the refresh button to refresh the current selection </p>
                    <br>
                    <p> Scored episodes and alerts are retained for <b> 30 days </b> before deletion </p>
                    <br>
                    <p> <b>Capped at 2000 alerts </b> </p>
                    <v-divider />
                    <p> Check the <b>reviewed</b> box and submit the alerts to mark them as reviewed. They will not appear in your alerts in the future. </p>
                    <p> Press the <b>'Show Reviewed Alerts'</b> button to show such alerts again. Check the <b>reviewed</b> box and submit the alerts to <b>insert them back into your live alert flow</b>. </p>
                    
                </template>
            </info>
        </v-toolbar>
        <v-card align-center justify-center>
            <v-flex class="px-4 py-2">
                <v-layout justify="center" align="center" fluid v-if="showTheBox">
                    <v-flex xs4>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" v-model="exclude_path_change" @change="excludeChange()">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include path change alerts </div>
                                    </template> 
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASNs are the same, i.e. no change of ownership
                            <br />
                            <b>(NOTE: path changes account for around 90-95% of alerts)</b>
                        </span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" v-model="exclude_first_seen" @change="excludeChange()">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include first seen prefix alerts</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4 v-if="showUserTen">
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" v-model="exclude_in_path" @change="excludeChange()">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new). <br />
                                Also filters out <b>restricted prefix</b> alerts.</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" v-model="exclude_own_assert" @change="excludeChange()">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs4>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-switch slot="activator" v-on="on" v-model="exclude_intra_org" @change="excludeChange()">
                                    <template v-slot:label>
                                        <div :style="$store.state.textFormatting.main">Include intra-org assertions</div>
                                    </template>
                                </v-switch>
                            </template>
                        <span :style="$store.state.textFormatting.main">Alerts where ownership assertions between ASNs belonging to the same organisation</span>
                        </v-tooltip>
                    </v-flex>
                

                    <v-flex class="py-2 px-1" v-if="allow_dealt" xs4 align-center justify-center>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <v-btn @click="updateDealtWithMany(1)" color="success" v-on="on" :style="$store.state.textFormatting.main"> Update reviewed </v-btn>        
                            </template>
                        <span :style="$store.state.textFormatting.main">Click here to remove the ticked alerts from your organisation's alerts</span>
                        </v-tooltip>
                        
                    </v-flex>

                </v-layout>
            </v-flex>
            <v-layout column justify-space-around v-if="showTheBox">
                <v-flex>
                    <v-data-table :headers="useHeaders" :items="current10Data"
                        :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination"
                        :expand="expand" class="custom-style" v-if="table_buffer">
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span slot="activator" :style="$store.state.textFormatting.main">
                                <div v-for="line in props.header.text" :key="line.index">
                                    <div> {{ line }} </div>
                                </div>
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td class="text-xs-center" :style="$store.state.textFormatting.main" v-if="showUserTen"> 
                                    <v-checkbox class="text-xs-center" hide-details v-if="!props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 1)" />
                                    <v-checkbox class="text-xs-center" hide-details v-if="props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 0)" />
                                </td>
                                
                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.alert_type }}</td>
                                
                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }}</td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                        </template>
                                        <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                    </v-tooltip>
                                    <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                </td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                        </template>
                                        <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                    </v-tooltip>
                                    <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                </td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )" v-if="is_asn_owners&&showUserTen&&!props.item.bonus_interest" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <div v-if="props.item.controlled_prefix=='null'">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.asn_of_interest]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.asn_of_interest }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn_of_interest] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.asn_of_interest]" :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </div>
                                    <div v-if="props.item.controlled_prefix!='null'">
                                        <div :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} </div>
                                    </div>
                                </td>

                                <td v-if="is_asn_owners&&showUserTen&&props.item.bonus_interest" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                    <div>
                                        <div :style="$store.state.textFormatting.main">
                                            {{ props.item.asn_of_interest }} 
                                            <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="!props.item.bonus_show" @click="viewBonus(props.item)"> add </v-icon> 
                                        
                                            <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="props.item.bonus_show" @click="viewBonus(props.item)"> remove </v-icon> 
                                            
                                            <small v-if="props.item.bonus_show">
                                                <br />
                                                AS: {{ props.item.bonus_interest }}
                                            </small>
                                        </div>
                                    </div>
                                </td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>

                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>

                                <!-- <td class="text-xs-center special"> {{ props.item.event_count }}</td> !-->
                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> <v-chip class="special" :color="getColor(props.item.interval_start.date)" text-color="#000000" dark :style="$store.state.textFormatting.main">{{ props.item.interval_start.date }}</v-chip> </td>

                                <!-- <td class="text-xs-center special"> {{ props.item.interval_start.date }}</td> -->
                                <td @click="clickHandler(props.item.prefix, 
                                props.item.origin_asn_old, props.item.origin_asn_new, props.item.time_5min,
                            )"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.time }}</td>
                            </tr>
                            
                        </template>
                        <template v-if="!isdata" slot="no-data">
                            <v-alert :key="id" :value="true" color="success" icon="warning" :style="$store.state.textFormatting.main">
                                No alerts, consider changing sliders above <v-icon> thumb_up</v-icon>
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
            <v-layout justify-center align-center v-if="showTheBox&&showUserTen">
                <v-flex xs4 class="px-2 py-2">
                    <v-btn color="success" v-if="allow_popped" @click="showPoppedAlerts()" :style="$store.state.textFormatting.main"> Show 'Reviewed' Alerts </v-btn>
                    <v-btn color="success" v-if="!allow_popped" @click="showUnpoppedAlerts()" :style="$store.state.textFormatting.main"> Show Live Alerts </v-btn>
                </v-flex>
            </v-layout>
            <v-layout justify-center align-center v-if="showTheBox&&showUserTen">
                <v-flex xs12 class="px-2 py-2">
                    <v-divider />
                </v-flex>
            </v-layout>
            <v-layout justify-center align-center v-if="showTheBox&&showUserTen">
                <v-flex xs1 />
                <v-flex xs4  class="px-2 py-2">
                    <v-btn color="success" @click="getAllUserAlerts(allRound)" :style="$store.state.textFormatting.main">  <v-icon>save_alt</v-icon> {{ downloadStr }} </v-btn>
                </v-flex>
                <v-spacer />
                <v-flex justify-center align-center class="px-2 py-2">
                    <v-icon v-if="allLoading" large> trending_flat </v-icon>
                    <v-progress-circular v-if="allLoading" indeterminate color="purple" />         
                    <v-icon v-if="allLoading" large> trending_flat </v-icon>

                    <h4 v-if="allErrMsg" :style="$store.state.textFormatting.main"> {{allErrMsg}} </h4>
                </v-flex>
                <v-flex xs4 class="px-2 py-2">
                    <downloadcsv
                    class   = "btn btn-default"
                    :data   = "allUserAlerts"
                    name = "organisationAlerts.csv">
                        <v-tooltip top eager color="primary" id="exit-app">
                            <template v-slot:activator="{ on }">
                                <v-btn small dark v-on="on" color="success" :disabled="!showAllDownload" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV </v-btn>
                            </template>
                            <span :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV of {{ oldDownStr }}</span>
                        </v-tooltip>
                        
                    </downloadcsv>
                </v-flex>
            </v-layout>
            <v-layout justify-center align-center v-if="showTheBox&&!showUserTen">
                <v-flex xs1 />
                <v-flex xs4  class="px-2 py-2">
                    <v-btn color="success" @click="getAllGlobalAlerts(allRound)" :style="$store.state.textFormatting.main">  <v-icon>save_alt</v-icon> {{ downloadStr }} </v-btn>
                </v-flex>
                <v-spacer />
                <v-flex justify-center align-center class="px-2 py-2">
                    <v-icon v-if="allLoading" large> trending_flat </v-icon>
                    <v-progress-circular v-if="allLoading" indeterminate color="purple" />         
                    <v-icon v-if="allLoading" large> trending_flat </v-icon>

                    <h4 v-if="allErrMsg" :style="$store.state.textFormatting.main"> {{allErrMsg}} </h4>
                </v-flex>
                <v-flex xs4 class="px-2 py-2">
                    <downloadcsv
                    class   = "btn btn-default"
                    :data   = "allGlobalAlerts"
                    name = "globalEpisodes.csv">
                        <v-tooltip top eager color="primary" id="exit-app">
                            <template v-slot:activator="{ on }">
                                <v-btn small dark v-on="on" color="success" :disabled="!showAllDownload" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV </v-btn>
                            </template>
                            <span :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV of {{ oldDownStr }}</span>
                        </v-tooltip>
                        
                    </downloadcsv>
                </v-flex>
            </v-layout>
        </v-card>

    </v-card>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import info from './infopopout.vue'
import { mdiArrowRight } from '@mdi/js';
import downloadcsv from 'vue-json-csv';
import moment from 'moment-timezone';

export default {
    name: 'top10',
    components: {
        info,
        downloadcsv
    },
    data () {
        return {
            tz:'UTC',
            allRound: 0,
            showTheBox: true,
            allUserAlerts: [],
            allGlobalAlerts: [],
            allLoading: false,
            allErrMsg: false,
            showAllDownload: false,
            downloadStr: "1000 most recent alerts",
            oldDownStr: "1000 most recent alerts",
            showUserTen: false,
            exclude_first_seen: false,
            exclude_path_change: false,
            exclude_in_path: false,
            exclude_own_assert: false,
            exclude_intra_org: true,
            userSpecificOrderBy: null,
            prefix: null,
            orderResultsBy: "hijack_score_mean",
            top10Message: "Recent Episodes",
            showUserTopTen: false,
            selectedAlertRouting: "/alert",
            pagination: {
                rowsPerPage: 10,
                sortBy: 'hijack_score_mean',
                descending: true
            },
            rowsPerPageItems: [10, 20, 30, 40, 50, 100],
            organisation: '',
            useHeaders: [
                { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            headers: [
                { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            headersGlobal: [
                //{ text: 'Reviewed', sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                //{ text: 'User ASN', value: 'asn_of_interest', align:'centre', ad_text: 'ASN designated by user which generated this alert'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            userorg: 'Org1',
            data: [],
            current10Data: [],
            id: null,
            alertperasn: [],
            isdata: true,
            updatedStr: "",
            loading: false,
            expand: false,
            ddinfo: {},
            orderByList: [{name: "New ASN", param: "origin_asn_new"},
                        {name: "Old ASN", param: "origin_asn_old"},
                        {name: "Time", param: "time_5min"},
                        {name: "Hijack Score", param: "hijack_score_mean"},
                        {name: "Impact Score", param: "impact_score_mean"},
                        //{name: "Validation Score", param: "event_count"},
                        {name: "Prefix", param: "prefix"}
            ],
            orderMatch: { "origin_asn_new": "Origin ASN New",
                    "origin_asn_old": "Origin ASN Old",
                    "time_5min": "Time",
                    "hijack_score_mean": "Hijack Score",
                    "impact_score_mean": "Impact Score",
                    //"event_count": "Validation Score",
                    "prefix": "Prefix"
            },
            allowExcludeSwitches: false,
            colors: [
                'tertiary',
                'secondary'
            ],
            colorpick: 'secondary',
            textheader: {
                fontSize: '20px'
            },
            textstandard: {
                fontSize: '14px'
            },
            asn_own_dict: {},
            asn_get_owner: [],
            is_asn_owners: true,
            to_be_dealt: [],
            allow_dealt: false,
            show_popped: '',
            allow_popped: true,
            alert_keys: {},
            table_buffer: true
        }
    },
    beforeMount () {
        if (this.$attrs.type) {
            if (this.$attrs.type == 'global') {
                this.showUserTen = false
            }
        }
    },
    mounted () {
        try {
            this.organisation = this.$store.state.user.organisation;
            this.headers[6].text[0] = this.organisation
            //this.username = this.$store.state.user.username;
        } catch (err) {
            console.log(err)
            location.reload()
        }
        this.exclude_path_change = this.$store.state.alertsExcPath
        this.exclude_first_seen = this.$store.state.alertsExcFirst
        this.exclude_in_path = this.$store.state.alertsExcInPath
        this.exclude_own_assert = this.$store.state.alertsExcOwnAssert
        //this.top10alertsUser();
        if (!this.$attrs.type) {
            this.showUserTen = true
        } else {
            if (this.$attrs.type != 'global') {
                this.showUserTen = true
            } else {
                this.top10Message = "Global episodes"
                this.useHeaders = this.headersGlobal
                this.top10alerts('refresh');
                this.colorpick = this.colors[0]
                this.$emit('changeAlerts',  this.showUserTen)
            }
        }
        
        this.allowExcludeSwitches = true;
    },
    methods: {
        viewBonus: async function (item) {
            item.bonus_show = !item.bonus_show
            this.table_buffer = false;
            this.$nextTick(() => {
                // Add the component back in
                this.table_buffer = true;
            });
        },
        getColor: function (indate) {
            let d_obj = new Date();
            let day = ("0" + d_obj.getUTCDate()).slice(-2);
            let mon = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
            let yr = d_obj.getUTCFullYear();
            let fdate = day + "/" + mon + "/" + yr;

            d_obj.setDate(d_obj.getUTCDate() - 1);
            let day2 = ("0" + d_obj.getUTCDate()).slice(-2);
            let mon2 = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
            let yr2 = d_obj.getUTCFullYear();
            let yfdate = day2 + "/" + mon2 + "/" + yr2;

            if (fdate == indate) {
                return '#FF6347'
            } else if ( yfdate == indate ) {
                return '#FFDAB9'
            } else {
                return '#ffffff'
            }
        },
        changeOrderBy: function (order, type) {
            if (type == "user") {
                this.orderResultsBy = order
                this.pagination.sortBy = null
                this.pagination.descending = null
                this.top10Message = this.organisation + " Alerts"
                this.top10alertsUser('refresh', order)
            } else if (type == "global") {
                this.orderResultsBy = order
                this.pagination.sortBy = null
                this.pagination.descending = null
                this.top10Message = "Global episodes"
                this.top10alerts('refresh', order)
            }
            
        },
        excludeChange: function () {
            if (this.showUserTen) {
                this.top10alertsUser('refresh', this.orderResultsBy)
            } else {
                this.top10alerts('refresh', this.orderResultsBy)
            }
            
        },
        top10alerts: async function (i, order) {
            if (order == null) {
                order = "hijack_score_mean"
            }
            this.loading = true;
            this.current10Data=[]
            try {
                
                    var query = `query top10 { getEpisodes(
                            page_offset:0, 
                            page_rows:1000, 
                            order_by: "`+order+`", 
                            exclude_path_change: ` + !this.exclude_path_change + `,
                            exclude_first_seen: ` + !this.exclude_first_seen + `,
                            exclude_own_assert: ` + !this.exclude_own_assert + `,
                            exclude_intra_org: ` + !this.exclude_intra_org + `
                        ) {
                            prefix,
                            origin_asn_new,
                            origin_asn_old,
                            hijack_score_min,
                            hijack_score_mean,
                            hijack_score_max,
                            impact_score_min,
                            impact_score_mean,
                            impact_score_max,
                            event_count,
                            time_5min
                            non_direct_prefix
                        }
                    }`;         
                    console.log(query)
                    const  top10data  = await API.graphql(graphqlOperation(query));
                    var t10 = top10data.data.getEpisodes
                    console.log(t10)
                    for (var n=0; n< t10.length; n=n+1) {
                        var epochTime = t10[n].time_5min
                        var dateTime = this.convertEpochtoTimeDate(epochTime);
                        t10[n].interval_start  = dateTime
                        t10[n].asn_of_interest = "N/A";
                        if (t10[n].non_direct_prefix == 'null') {
                            t10[n].non_direct_prefix = 'N/A'
                        }

                        if (!(this.asn_get_owner.includes((t10[n].asn_of_interest).toString()))) {
                            this.asn_get_owner.push(t10[n].asn_of_interest.toString())
                        }
                        if (!(this.asn_get_owner.includes((t10[n].origin_asn_old).toString()))) {
                            this.asn_get_owner.push(t10[n].origin_asn_old.toString())
                        }
                        if (!(this.asn_get_owner.includes((t10[n].origin_asn_new).toString()))) {
                            this.asn_get_owner.push(t10[n].origin_asn_new.toString())
                        }

                        t10[n].alert_type = this.getAlertType(t10[n])

                        //t10[n].validation = t10[n].event_count;
                        if (n == t10.length - 1 ) {
                            this.getASNOwners()
                        }
                    }
                    var d = new Date();
                    var day = ("0" + d.getUTCDate()).slice(-2);
                    var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                    var year = d.getUTCFullYear()
                    var dateFormatted = day + "/" + month + "/" + year
                    var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                    this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
                    console.log("updated at: " + this.updatedStr)
                    this.$store.state.top10alerts = t10;
                    this.id=this.id+1
                    this.current10Data = t10;
                    if(this.isEmpty(t10)) {
                        this.isdata = false;
                        this.loading = false
                    } else {
                        this.isdata = true;
                        this.loading = false;
                    } 
                
            }
            catch (err) {
                console.log(err)
                this.loading = false;
                this.isdata=false;
            }
                this.loading = false;
        },

        getAllGlobalAlerts: async function (n) {
            try {
                this.showAllDownload = false;
                this.allUserAlerts = [];
                this.allLoading = true;
                this.allErrMsg = false;
                var query = `query top10 { getEpisodes(
                            page_offset: ` + (n * 1000) + `, 
                            page_rows: 1000, 
                            order_by: "`+this.orderResultsBy+`", 
                            exclude_path_change: ` + !this.exclude_path_change + `,
                            exclude_first_seen: ` + !this.exclude_first_seen + `,
                            exclude_own_assert: ` + !this.exclude_own_assert + `,
                            exclude_intra_org: ` + !this.exclude_intra_org + `
                        ) {
                            prefix,
                            origin_asn_new,
                            origin_asn_old,
                            hijack_score_min,
                            hijack_score_mean,
                            hijack_score_max,
                            impact_score_min,
                            impact_score_mean,
                            impact_score_max,
                            event_count,
                            time_5min
                            non_direct_prefix
                        }
                    }`;
                console.log(query)        
                const  allAlertsData  = await API.graphql(graphqlOperation(query));
                console.log(allAlertsData)
                var allAlerts = allAlertsData.data.getEpisodes
                console.log(allAlerts)
                if (allAlerts) {
                    if (allAlerts.length > 0 && allAlerts[0].prefix != null) {
                        var urldata = window.location.origin + "/#/alertFromTop10/"

                        for (var n=0; n< allAlerts.length; n=n+1) {

                            allAlerts[n].alert_url = urldata + allAlerts[n].prefix.replace("/", "%2F") + "~" + allAlerts[n].origin_asn_old + "~" + allAlerts[n].origin_asn_new + "~" + allAlerts[n].interval_start

                            allAlerts[n].alert_type = this.getAlertType(allAlerts[n])

                            var epochTime = allAlerts[n].interval_start
                            var dateTime = this.convertEpochtoTimeDate(epochTime);
                            allAlerts[n].time_5min = epochTime
                            allAlerts[n].interval_start  = dateTime.date + dateTime.time;
                        }
                        this.allGlobalAlerts = allAlerts;
                        this.allLoading = false;
                        this.showAllDownload = true; 
                    } else {
                        if (n > 0) {
                            this.allErrMsg = "No additional alerts"
                            this.allLoading = false;
                            if (n == 1) {
                                this.downloadStr = "1000 most recent alerts";
                                this.allRound = 0;
                            } else {
                                this.allRound += -1;
                                this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                            }
                        } else {
                            this.allErrMsg = "No alerts"
                            this.allLoading = false;
                        }
                    }
                    if (allAlerts.length > 999) {
                        this.allRound += 1
                        this.oldDownStr = this.downloadStr;
                        this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                    }
                    
                } else {
                    this.allUserAlerts = false
                    this.allErrMsg = "No alerts"
                    this.allLoading = false;
                    
                }
                        
            } catch (err) {
                this.allUserAlerts = false
                console.log(err)
                this.allErrMsg = "Error pulling all alerts"
                this.allLoading = false;
            }
        },
        
        getAllUserAlerts: async function (n) {
            try {
                this.showAllDownload = false;
                this.allUserAlerts = [];
                this.allLoading = true;
                this.allErrMsg = false;
                var query = `query top10 { getNotificationsForOrg (
                        page_offset: ` + (n * 1000) + `, 
                        page_rows: 1000, 
                        order_by:"`+ this.orderResultsBy +`",
                        exclude_path_change: ` + !this.exclude_path_change + `,
                        exclude_first_seen: ` + !this.exclude_first_seen + `,
                        exclude_in_path: ` + !this.exclude_in_path + `,
                        exclude_own_assert: ` + !this.exclude_own_assert + `,
                        exclude_intra_org: ` + !this.exclude_intra_org + `
                    ) {
                        prefix
                        origin_asn_new
                        origin_asn_old
                        interval_start
                        hijack_score_min
                        impact_score_min
                        hijack_score_max
                        impact_score_max
                        hijack_score_mean
                        impact_score_mean
                        asn_of_interest
                        validation
                        event_count
                        countdown
                        email_count
                        organisation_name
                        notified_organisation
                        asn_class
                        dealt_with
                        controlled_prefix
                        non_direct_prefix
                    }  
                }`;
                console.log(query)        
                const  allAlertsData  = await API.graphql(graphqlOperation(query));
                console.log(allAlertsData)
                var allAlerts = allAlertsData.data.getNotificationsForOrg
                console.log(allAlerts)
                if (allAlerts) {
                    if (allAlerts.length > 0 && allAlerts[0].asn_class != null) {
                        var urldata = window.location.origin + "/#/alertFromTop10/"

                        for (var n=0; n< allAlerts.length; n=n+1) {

                            if (allAlerts[n].asn_of_interest == '99999999999') {
                                allAlerts[n].asn_of_interest = 'Restricted Prefix';
                            }

                            allAlerts[n].alert_url = urldata + allAlerts[n].prefix.replace("/", "%2F") + "~" + allAlerts[n].origin_asn_old + "~" + allAlerts[n].origin_asn_new + "~" + allAlerts[n].interval_start

                            allAlerts[n].alert_type = this.getAlertType(allAlerts[n])

                            var epochTime = allAlerts[n].interval_start
                            var dateTime = this.convertEpochtoTimeDate(epochTime);
                            allAlerts[n].time_5min = epochTime
                            allAlerts[n].interval_start  = dateTime.date + dateTime.time;
                        }
                        this.allUserAlerts = allAlerts;
                        this.allLoading = false;
                        this.showAllDownload = true; 
                    } else {
                        if (n > 0) {
                            this.allErrMsg = "No additional alerts"
                            this.allLoading = false;
                            if (n == 1) {
                                this.downloadStr = "1000 most recent alerts";
                                this.allRound = 0;
                            } else {
                                this.allRound += -1;
                                this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                            }
                        } else {
                            this.allErrMsg = "No alerts"
                            this.allLoading = false;
                        }
                    }
                    if (allAlerts.length > 999) {
                        this.allRound += 1
                        this.oldDownStr = this.downloadStr;
                        this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                    }
                    
                } else {
                    this.allUserAlerts = false
                    this.allErrMsg = "No alerts"
                    this.allLoading = false;
                    
                }
                        
            } catch (err) {
                this.allUserAlerts = false
                console.log(err)
                this.allErrMsg = "Error pulling all alerts"
                this.allLoading = false;
            }
        },
        getAnASNOwner: async function(asn) {
            if (asn == 0 || asn == 'N/A') {
                return "None";
            } else if (asn == 'Restricted Prefix') {
                return "Restricted Prefix"
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    //console.log("UPDATETICKER")
                    this.is_asn_owners = false
                    this.$nextTick(() => {
                        // Add the component back in
                        this.is_asn_owners = true;
                    });
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        tagDealtWith: async function (entry, tag) {
            entry.dealt_with = tag
            //console.log(entry)
            //console.log(tag)
            //console.log(this.current10Data.indexOf(entry))
            if ( tag == 1 ) {
                if ( entry.asn_of_interest == 'Restricted Prefix' ) {
                    this.to_be_dealt.push({
                        prefix: entry.prefix,
                        origin_asn_new: entry.origin_asn_new,
                        origin_asn_old: entry.origin_asn_old,
                        time_5min: entry.time_5min,
                        asn_of_interest: 99999999999,
                        notified_organisation: entry.notified_organisation,
                        user: entry.user,
                        pos: this.current10Data.indexOf(entry)
                    })
                } else {
                    this.to_be_dealt.push({
                        prefix: entry.prefix,
                        origin_asn_new: entry.origin_asn_new,
                        origin_asn_old: entry.origin_asn_old,
                        time_5min: entry.time_5min,
                        asn_of_interest: entry.asn_of_interest,
                        notified_organisation: entry.notified_organisation,
                        user: entry.user,
                        pos: this.current10Data.indexOf(entry)
                    })
                }
                
            } else {
                for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
                    if ( this.to_be_dealt[i].prefix == entry.prefix &&
                        this.to_be_dealt[i].origin_asn_new == entry.origin_asn_new &&
                        this.to_be_dealt[i].origin_asn_old == entry.origin_asn_old &&
                        this.to_be_dealt[i].time_5min == entry.time_5min &&
                        this.to_be_dealt[i].asn_of_interest == entry.asn_of_interest &&
                        this.to_be_dealt[i].notified_organisation == entry.notified_organisation &&
                        this.to_be_dealt[i].user == entry.user
                    ) {
                        this.to_be_dealt.splice( i , 1 )
                        i -= 1
                    }
                }
            }
            if ( this.to_be_dealt.length > 0 ) {
                this.allow_dealt = true
            } else {
                this.allow_dealt = false
            }

        },
        updateDealtWithMany: async function (dealt_w) {
            // (`prefix`, origin_asn_new, origin_asn_old, time_5min, asn_of_interest, organisation_name, `user`)
            var sendings = []
            var to_go = []
            if ( this.show_popped != '' ) {
                dealt_w = 0
            }

            for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
                var entry = this.to_be_dealt[i]
                sendings.push(
                    String.raw`(\"` + entry.prefix + String.raw`\",`
                    + entry.origin_asn_new + `,` 
                    + entry.origin_asn_old + `,` 
                    + entry.time_5min + `,` 
                    + entry.asn_of_interest + `,` 
                    + String.raw`\"` + entry.notified_organisation + String.raw`\",\"` 
                    + entry.user + String.raw`\")`
                )
                to_go.push(entry.pos)
            }
            var sendstr = sendings.join(",")
            try {
                var query = `query getUpdateDealtWithMany { 
                    getUpdateDealtWithMany (
                        update_str: "` + sendstr + `", 
                        p_dealt_with: ` + dealt_w + `
                    )
                    {
                        ts
                    }  
                }`;
                console.log(query) 
                const updata = await API.graphql(graphqlOperation(query));
                //console.log(updata)
                var updated = updata.data.getUpdateDealtWithMany
                if ( parseInt(updated[0].ts) == 1 ) {
                    console.log("updated successfully")
                }
            } catch (err) {
                console.log(err)
            }
            to_go.sort()
            //console.log(to_go)
            for ( var i = this.to_be_dealt.length - 1 ; i > -1 ; i-- ) {
                //console.log(to_go[i])
                this.current10Data.splice(to_go[i], 1)
            }
            this.to_be_dealt = []
            this.allow_dealt = false
        },
        showPoppedAlerts: async function () {
            this.show_popped = ", p_dealt_with: 1 "
            this.allow_popped = false
            this.top10alertsUser()
        },
        showUnpoppedAlerts: async function () {
            this.show_popped = ""
            this.allow_popped = true
            this.top10alertsUser()
        },
        getAlertType: function (alert) {
            /* if (alert.asn_of_interest == 'Restricted Prefix') {
                return 'Restricted Prefix'
            } else */
            if (alert.origin_asn_old == '0' || alert.origin_asn_old == 0) {
                return 'First Seen Prefix'
            } else if (alert.origin_asn_new == alert.origin_asn_old) {
                return 'Path Change'
            } else {
                if (alert.non_direct_prefix == 'N/A' || !alert.non_direct_prefix) {
                    return 'Ownership Assertion'
                } else {
                    var nd_cidr = parseInt(alert.non_direct_prefix.split("/")[1])
                    var cidr = parseInt(alert.prefix.split("/")[1])
                    if (nd_cidr > cidr) {
                        return 'Super-ownership Assertion'
                    } else {
                        return 'Sub-ownership Assertion'
                    }

                }
            }
        },
        top10alertsUser: async function (i, order) {
            if (order == null) {
                order = "hijack_score_mean"
            }
            this.showUserTen = true
            this.loading = true;
            this.current10Data = []
            this.to_be_dealt = []
            this.alert_keys = {}
            this.allow_dealt = false
            try {
                
                    var query = `query top10 { getNotificationsForOrg (
                            page_offset: 0, 
                            page_rows: 2000, 
                            order_by:"`+order+`",
                            exclude_path_change: ` + !this.exclude_path_change + `,
                            exclude_first_seen: ` + !this.exclude_first_seen + `,
                            exclude_in_path: ` + !this.exclude_in_path + `,
                            exclude_own_assert: ` + !this.exclude_own_assert + `,
                            exclude_intra_org: ` + !this.exclude_intra_org + 
                            this.show_popped + `
                        ) {
                            prefix
                            origin_asn_new
                            origin_asn_old
                            interval_start
                            hijack_score_min
                            impact_score_min
                            hijack_score_max
                            impact_score_max
                            hijack_score_mean
                            impact_score_mean
                            asn_of_interest
                            validation
                            event_count
                            countdown
                            email_count
                            organisation_name
                            notified_organisation
                            asn_class
                            dealt_with
                            user
                            controlled_prefix
                            non_direct_prefix
                        }  
                    }`;
//                    console.log(query)        
                    const  top10data  = await API.graphql(graphqlOperation(query));
//                    console.log(top10data)
                    var t10 = top10data.data.getNotificationsForOrg
//                    console.log(t10)
                    var is_new;
                    
                    for (var n=0; n< t10.length; n=n+1) {
                        if (!(t10[n].prefix)) {
                            break
                        }

                        is_new = true

                        var epochTime = t10[n].interval_start
                        var dateTime = this.convertEpochtoTimeDate(epochTime);
                        t10[n].time_5min = epochTime
                        t10[n].interval_start  = dateTime

                        if (t10[n].asn_of_interest == '99999999999') {
                            t10[n].asn_of_interest = 'Restricted Prefix';
                        }
                        if (t10[n].non_direct_prefix == 'null') {
                            t10[n].non_direct_prefix = 'N/A'
                        }

                        t10[n].alert_type = this.getAlertType(t10[n])

                        t10[n].dealt_with_t = false
                        
                        if (!(this.asn_get_owner.includes((t10[n].asn_of_interest).toString()))) {
                            this.asn_get_owner.push(t10[n].asn_of_interest.toString())
                        }

                        if (!(this.asn_get_owner.includes((t10[n].origin_asn_old).toString()))) {
                            this.asn_get_owner.push(t10[n].origin_asn_old.toString())
                        }
                        if (!(this.asn_get_owner.includes((t10[n].origin_asn_new).toString()))) {
                            this.asn_get_owner.push(t10[n].origin_asn_new.toString())
                        }

                        // we set the asn of interest to the restricted prefix for display purposes
                        if (t10[n].controlled_prefix != 'null' && t10[n].asn_of_interest == 'Restricted Prefix') {
                            t10[n].asn_of_interest = t10[n].controlled_prefix
                        }
                        
                        // de-duplication
                        if (!(Object.keys(this.alert_keys).includes(t10[n].prefix))) {
                            this.alert_keys[t10[n].prefix] = {}
                        }
                        if (!(Object.keys(this.alert_keys[t10[n].prefix]).includes(t10[n].time_5min))) {
                            this.alert_keys[t10[n].prefix][t10[n].time_5min] = []
                        }
                        if (this.alert_keys[t10[n].prefix][t10[n].time_5min].includes((t10[n].origin_asn_old + "," + t10[n].origin_asn_new).toString())) {
                            is_new = false
                            //console.log("OLD ALERT")
                            //console.log(t10[n])
                            for (var j = 0 ; j < this.current10Data.length ; j++ ) {
                                var currentAlert = this.current10Data[j]
                                if (
                                    currentAlert.prefix == t10[n].prefix && 
                                    currentAlert.origin_asn_new == t10[n].origin_asn_new && 
                                    currentAlert.origin_asn_old == t10[n].origin_asn_old && 
                                    currentAlert.time_5min == t10[n].time_5min
                                ) {
                                    currentAlert.impact_score_mean = Math.max(currentAlert.impact_score_mean, t10[n].impact_score_mean)
                                    if (!(currentAlert.asn_of_interest.includes('/'))) {
                                        currentAlert.bonus_interest = currentAlert.asn_of_interest
                                        currentAlert.asn_of_interest = t10[n].asn_of_interest
                                        currentAlert.bonus_show = false
                                        console.log(currentAlert)
                                    } else {
                                        currentAlert.bonus_interest = t10[n].asn_of_interest
                                        currentAlert.bonus_show = false
                                        console.log(currentAlert)
                                    }
                                }
                            }
                        } else {
                            this.alert_keys[t10[n].prefix][t10[n].time_5min].push(
                                (t10[n].origin_asn_old + "," + t10[n].origin_asn_new).toString()
                            )
                        }

                        if (is_new) {
                            this.current10Data.push(t10[n])
                        }

                        if (n == t10.length - 1 ) {
                            this.getASNOwners()
                        }
                    }

                    this.$store.state.top10alerts = t10;
                    var d = new Date();
                    var day = ("0" + d.getUTCDate()).slice(-2);
                    var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                    var year = d.getUTCFullYear()
                    var dateFormatted = day + "/" + month + "/" + year
                    var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                    this.updatedStr = "U: " + dateFormatted + " " + timeFormatted
                    console.log("updated at: " + this.updatedStr)

                    this.id=this.id+1
                    //this.current10Data = t10;
                    
                    
                    
                    if(t10.length < 1) {
                        this.current10Data = [];
                        this.isdata = false;
                        this.loading = false
                    } else {
                        if (t10[0].prefix == null) {
                            this.current10Data = [];
                            this.isdata = false;
                            this.loading = false
                        } else {
                            this.isdata = true;
                            this.loading = false;
                        }
                        
                    } 

                
            }
            
            catch (err) {
                this.current10Data = false;
                console.log(err)
                this.loading = false;
                this.isdata=false;
                var d = new Date();
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);
                this.updatedStr = "U: " + dateFormatted + " " + timeFormatted

            }
            this.loading = false;
            
        },
        clickHandler: function (prefix, old_asn, new_asn, timeEpoch) {
            var paramatersCombined = prefix+"~"+old_asn+"~"+new_asn+"~"+timeEpoch
            let routeData = this.$router.resolve({name: 'Alert From Top 10', params: {prefix: paramatersCombined}});
            window.open(routeData.href, '_blank');
            //this.$router.push({ name: 'Alert From Top 10', 
            //                                params: {prefix: paramatersCombined}})
        },
        isEmpty: function(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
                var d = new Date( epochTime *1000);

//                var day = ("0" + d.getUTCDate()).slice(-2);
//                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
//                var year = d.getUTCFullYear()
//                var dateFormatted = day + "/" + month + "/" + year
//                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

//                var dateTime  = {"date": dateFormatted, "time": timeFormatted}
                var dateFormatted = moment.unix(epochTime).tz(this.tz).format('DD/MM/YYYY')
                var timeFormatted = moment.unix(epochTime).tz(this.tz).format('HH:mm:ss')
                var dateTime  = {"date": dateFormatted, "time": timeFormatted}

                return dateTime
            }
            catch(err) {
                console.log(err)
            }

        }
    },
    watch: {
        showUserTen(n) {
            if (n==true) {
                this.top10Message = this.organisation + " Alerts"
                this.useHeaders = this.headers
                this.top10alertsUser('refresh');
                this.colorpick = this.colors[1]
                this.$emit('changeAlerts',  this.showUserTen)
                this.allRound = 0
            } else {
                this.top10Message = "Global episodes"
                this.useHeaders = this.headersGlobal
                this.top10alerts('refresh');
                this.colorpick = this.colors[0]
                this.$emit('changeAlerts',  this.showUserTen)
                this.allRound = 0
            }
        },     
        exclude_first_seen(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcFirst", n);
            }
            
            console.log("changing first seen")
            console.log(this.$store.state.alertsExcFirst)
        },
        exclude_path_change(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcPath", n);
            }
            console.log("changing path change")
            console.log(this.$store.state.alertsExcPath)
        },
        exclude_in_path(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcInPath", n);
            }
            console.log("changing in path")
            console.log(this.$store.state.alertsExcInPath)
        },
        exclude_own_assert(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcOwnAssert", n);
            }
            console.log("changing in path")
            console.log(this.$store.state.alertsExcInPath)
        },
        exclude_intra_org(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcIntraOrg", n);
            }
            console.log("changing in path")
            console.log(this.$store.state.alertsExcIntraOrg)
        }
    }
    
};

</script>

<style scoped>
    
    .v-input__slot {
        align-items: center;
        justify-content: center;
    }

    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    table.v-table tbody td, 
    table.v-table tbody th {
        height: 38px;
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

    .special
    {
        cursor: pointer;
    }

</style>